/**
 * True only for a value that looks like a real, fetchable media URL.
 *
 * A bug in the upload service could previously let a failed upload persist
 * its own error message as `media_url` (e.g. "The request signature we
 * calculated does not match the signature you provided..."), which then
 * rendered as a dead <img>/<video> on the approval queue. Renderers should
 * filter attachments through this before treating them as displayable
 * media.
 */
export const isRenderableMediaUrl = (url: unknown): boolean =>
  typeof url === "string" && /^(https?:)?\/\//i.test(url.trim());
